var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskPanel',{attrs:{"taskInfos":_vm.taskInfos,"titleImage":_vm.titleImage,"buttonImage":_vm.buttonImage,"taskStatusTextMap":_vm.taskStatusTextMap},on:{"doTask":_vm.handleDoTask,"refreshTaskInfo":_vm.refreshTaskInfo,"reportClick":_vm.reportClick,"reportCollapseSwitch":_vm.reportCollapseSwitch,"launchShare":_vm.handleLaunchShare}})
}
var staticRenderFns = []

export { render, staticRenderFns }